import apiClient from '@/api/index'
import router from '@/router';

export const motivationTatarModule = {
    namespaced: true,

    state:() => ({
        reportData: {},
        reportLoading: true,
        filterset: {},
        filtersetLoading: true,
        filterSpecs: {},
        excelData: {},
    }),

    mutations: {
        setReportData(state, data) {
            state.reportData = data
        },

        setReportFilterset(state, data) {
            // Сброс фильтров дат и времени
            state.filterSpecs['date_range'] = [];

            const queries = router.currentRoute.value.query;

            if (Object.keys(queries).length === 0) {
                // Если нет query-параметров, выставляем фильтры по умолчанию из filterset
                Object.entries(data).forEach(([filter, filterData]) => {
                    if (filter === 'title') return;

                    if (filter === 'date_range') {
                        state.filterSpecs[filter] = filterData.choices.map(choice => choice.value);
                    } else {
                        const checked = filterData.choices.find(choice => choice.checked);
                        state.filterSpecs[filter] = checked ? checked.value : '';
                    }
                });
            } else {
                // Если есть query-параметры, выставляем фильтры из них
                state.filterSpecs['date_range'] = [
                    queries.date_from || '',
                    queries.date_to || ''
                ];

                state.filterSpecs['shop'] = queries.shop ? Number(queries.shop) : '';
            }

            state.filterset = data;
            state.filtersetLoading = false;
        },

        setExcelData(state, data) {
            state.excelData = data
        }
    },

    actions: {
        async getReportData({ commit, state }) {
            state.reportLoading = true
            // Проверяет, есть ли параметры которые можно передать в запросе
            if(router.currentRoute.value.fullPath.split('?')[1]) {
                try {
                    const response = await apiClient.get("/reports/motivation_tatar/data?" + router.currentRoute.value.fullPath.split('?')[1], {
                        headers: {
                            Authorization: 'Token ' + localStorage.getItem('token')
                        }
                    })
                    console.log(response.data);
                    commit('setReportData', response.data.data)
                    commit('setExcelData', response.data)
                } catch(err) { // Если есть ошибка
                    alert(err)
                }
            // Если нет, делать запрос без параметров
            } else {
                try {
                    const response = await apiClient.get("/reports/motivation_tatar/data", {
                        headers: {
                            Authorization: 'Token ' + localStorage.getItem('token')
                        }
                    })
                    console.log(response.data);
                    commit('setReportData', response.data.data)
                    commit('setExcelData', response.data)
                } catch(err) { // Если есть ошибка
                    alert(err)
                }
            }

            state.reportLoading = false
        },

        async getReportFilterset({ commit, state }) {
            try {
                const response = await apiClient.get("/reports/motivation_tatar/filterset", {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    }
                })
                commit('setReportFilterset', response.data)
                state.filtersetLoading = false
            } catch(err) { // Если есть ошибка
                alert(err)
            }
        },

        resetFilters({ state }) {
            for(let filter in state.filterset) {
                state.filterSpecs[filter] = []

                if(filter !== 'title') {
                    for(let i = 0; i < state.filterset[filter].choices.length; i++) {
                        if(filter === 'date_range') {
                            state.filterSpecs[filter].push(state.filterset[filter].choices[i].value)
                        } else {
                            if(state.filterset[filter].choices[i].checked) {
                                state.filterSpecs[filter] = state.filterset[filter].choices[i].value
                            }
                        }
                    }
                }
            }
        },

        async getExcelFile({ state }) {
            try {
                const response = await apiClient.post("/reports/export_to_excel/",
                state.excelData,
                {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    },
                    responseType: 'blob'
                })
                const now = new Date()
                const url = URL.createObjectURL(response.data)
                const a = document.createElement('a')
                a.href = url
                a.download = `${state.excelData.title}_${now.toLocaleDateString()}.xls`
                a.style.display = 'none'
                document.body.appendChild(a)
                a.click()
                a.remove()
                URL.revokeObjectURL(url)
                
            } catch(err) { // Если есть ошибка
                alert(err)
            }
        },
    }
}